import React from "react";

function OnboadingFooter({
  page,
  setPage,
  handleSubmit,
  handlePreviousButtonClick,
  completeOnboarding,
}) {
  const pageIndicationArr = [1, 2, 3, 4, 5, 6, 7];

  return (
    <div className="absolute w-full bottom-2">
      <div
        className={` ${
          page === 1 || page === 7
            ? "hidden"
            : "flex justify-between items-center w-full px-16"
        }`}
      >
        <button
          className="btn bg-white border-slate-200 hover:border-slate-300 text-[#1E293B] text-[15px] leading-10 font-semibold cursor-pointer rounded-full w-[100px]"
          onClick={() => handlePreviousButtonClick()}
        >
          Previous
        </button>
        <button
          className="btn bg-[#2f80ed] hover:bg-[#136be0] text-white rounded-full font-semibold text-[15px] w-[100px]"
          onClick={() => handleSubmit()}
        >
          Next
        </button>
        {/* {page === 7 ? (
          <div className="space-x-4">
            <button
              className="btn bg-white border-slate-200 hover:border-slate-300 text-[#1E293B] text-[15px] leading-10 font-semibold cursor-pointer rounded-full w-[100px]"
              onClick={() => {
                completeOnboarding();
              }}
            >
              Skip
            </button>
            <button
              className="btn bg-[#2f80ed] hover:bg-[#136be0] text-white rounded-full font-semibold text-[15px] w-[100px]"
              onClick={() => handleSubmit()}
            >
              Next
            </button>
          </div>
        ) : (
          <button
            className="btn bg-[#2f80ed] hover:bg-[#136be0] text-white rounded-full font-semibold text-[15px] w-[100px]"
            onClick={() => {
              if (page > 1 && page < 7) {
                handleSubmit();
              } else {
                console.log('yor are in else codition with page no. --', page)
                setPage(page + 1);
              }
            }}
          >
            Next
          </button>
        )} */}
      </div>
      <div className="flex justify-center items-center space-x-4 py-3">
        {pageIndicationArr.map((element) => (
          <div
            className={`rounded-full h-[18px] w-[18px] ${
              page === element ? "bg-[#2f80ed]/40" : "bg-white"
            }  flex justify-center items-center`}
          >
            <div
              className={`h-[10px] w-[10px] rounded-full ${
                element <= page ? "bg-[#2f80ed]" : "bg-[#D9D9D9]"
              } `}
            ></div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default OnboadingFooter;
